import * as Yup from 'yup';

import { translate } from '@utils';

export const getValidationSchema = () => {
  return {
    firstName: Yup.string().required(
      translate('subModules/name:validation.required')
    ),
    lastName: Yup.string().required(
      translate('subModules/name:validation.required')
    ),
  };
};
